import PropTypes from 'prop-types'
import React from 'react'
import Base from './BaseContainer'
import { connect } from 'react-redux'

import { fetchAppsAction } from '../services/ws/AppWS'
import { clearMediasActions } from '../services/ws/LibraryWS'
import MenuComponent from '../components/Menu/Menu'
import Constants from '../services/constants/Constants'
import { hasAuthorization } from '../ContentUtils'
import { withRouter } from 'react-router-dom'

class Menu extends Base {

  _handleSetApp = childIndex => {
    if (childIndex > -1) {
      this.props.setChildApp(this.props.globalApp.children[childIndex], this.props.globalApp)
    } else {
      this.props.setChildApp(this.props.globalApp, this.props.globalApp)
    }
    this.props.clearMedias()
    // this.props.history.push('/' + Constants.RoutesConstants.app.dashboard + '/')
  }

  render() {
    let canEditApp = hasAuthorization(this.props.user, Constants.AuthConstants.UPDATE_APP)
    let defaultLocale
    if (this.props.app && this.props.app.locales) {
      this.props.app.locales.forEach((appLocale, index) => {
        if (appLocale.isDefault) defaultLocale = appLocale.locale.code
      })
    }

    if (!defaultLocale) {
      defaultLocale = this.props.locale
    }

    return (
      <MenuComponent
        onMenuClick={this.props.onBurgerClick}
        // onMenuItemClick={this._handleMenuItemClick}
        isMenuOpen={this.props.openedMenu}
        isHeaderDisplayed={this.props.fullHeader}
        selectedMenuItem={this.props.selectedMenuItem}
        currentApp={this.props.app}
        globalApp={this.props.globalApp}
        lang={defaultLocale}
        onAppChange={this._handleSetApp}
        contents={this.props.contents}
        path={this.props.location.pathname}
        canEditApp={canEditApp}
        onAppEdit={this.props.handleEditApp}
        appEditorOpened={this.props.appEditorOpened}
        isReplacing={this.props.isReplacing}
      />
    )
  }

}

Menu.propTypes = {
  dispatch: PropTypes.func.isRequired,
  openedMenu: PropTypes.bool.isRequired,
  fullHeader: PropTypes.bool.isRequired,
  onBurgerClick: PropTypes.func.isRequired,
  onLibClick: PropTypes.func.isRequired,
  app: PropTypes.object.isRequired,
  globalApp: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  setChildApp: PropTypes.func.isRequired,
  clearMedias: PropTypes.func.isRequired,
}

const mapStateToProps = ({
  authWS: { user },
  appWS: { app, globalApp },
  i18n: { locale },
  contentWS: { contents },
  libraryWS: { isReplacing },
}) => ({
  user,
  app,
  globalApp,
  locale,
  contents,
  isReplacing,
})

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
  setChildApp(app, allApps) {
    fetchAppsAction(dispatch, app, allApps).setChildAppInStore()
  },
  clearMedias() {
    clearMediasActions(dispatch).clearMediasFromStore()
  },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu))
